import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './public/home/home.component';
import {PageNotFoundComponent} from './public/page-not-found/page-not-found.component';
import {PublicContainerComponent} from './public/public-container/public-container.component';
import {PrivateContainerComponent} from './private/private-container/private-container.component';
import {DashboardComponent} from './private/dashboard/dashboard.component';
import {ListAdminsComponent} from './private/users/admins/list-admins/list-admins.component';
import {ListCustomersComponent} from './private/users/customers/list-customers/list-customers.component';
import {ReservedRoutesGuard} from './guards/reserved-routes.guard';
import {ListCompaniesComponent} from './private/companies/list-companies/list-companies.component';
import {ProfileManagementComponent} from './private/profile/profile-management/profile-management.component';
import {ListResearchersComponent} from './private/users/researchers/list-researchers/list-researchers.component';
import {ListLogisticsComponent} from './private/users/logistics/list-logistics/list-logistics.component';
import {ListContractsComponent} from "./private/contracts/list-contracts/list-contracts.component";
import {ListTestbedsComponent} from "./private/testbeds/list-testbeds/list-testbeds.component";
import {ListBoxesComponent} from "./private/boxes/list-boxes/list-boxes.component";
import {ListSimsComponent} from "./private/sims/list-sims/list-sims.component";
import {ListBoxInterfacesComponent} from "./private/box-interfaces/list-box-interfaces/list-box-interfaces.component";
import {ListStorageComponent} from "./private/storage/list-storage/list-storage.component";
import {
  ListBoxCertificatesComponent
} from "./private/box-certificates/list-box-certificates/list-box-certificates.component";
import {
  ListResearcherCertificatesComponent
} from "./private/researcher-certificates/list-researcher-certificates/list-researcher-certificates.component";
import {BoxLogsComponent} from './private/diagnostics/box-logs/box-logs/box-logs.component';
import {InvoicesSetupComponent} from './private/invoices/invoices-setup/invoices-setup.component';
import {InvoicesItemsComponent} from './private/invoices/invoices-items/invoices-items.component';
import {BillingSetupComponent} from './private/billing/setup/setup.component';
import {ItemsComponent} from "./private/billing/items/items.component";
import {
  ClientDownloadPageComponent
} from './private/client-download/client-download-page/client-download-page.component';

import {Constants} from "./utils/constants";
import {EmailVerificationComponent} from './public/email-verification/email-verification.component';
import {UserProfileComponent} from './private/profile/user-profile/user-profile.component';
import {TestOutputPageComponent} from './private/test/test-output-page/test-output-page.component';
import {TestListPageComponent} from './private/test/test-list-page/test-list-page.component';
import {ListTestersComponent} from './private/users/tester/list-testers/list-testers.component';
import {ExecuteListComponent} from './private/execute-list/execute-list.component';
import {LoginComponent} from "./public/login/login.component";
import { AddTestImageComponent } from './private/test-image/add-test-image/add-test-image.component';
import { ListTestImageComponent } from './private/test-image/list-test-image/list-test-image.component';
import {PreventRouteOnKeycloakGuard} from "./guards/prevent-route-on-keycloak.guard";


const routes: Routes = [
  {
    path: '',
    component: PublicContainerComponent,
    children: [
      {path: '', component: HomeComponent},
      {path: 'login', component: LoginComponent, canActivate: [PreventRouteOnKeycloakGuard]},
      {path: 'email-verification', component: EmailVerificationComponent}
      // {path: 'registration', component: CompanyFormComponent, data: {isRegistrationRequest: true}}
    ]
  },
  {
    path: 'reserved',
    canActivate: [ReservedRoutesGuard],
    component: PrivateContainerComponent,
    children: [
      { path: '', component: DashboardComponent },
      {
        path: 'add-test-image/:companyId', component: AddTestImageComponent,
        canActivate: [ReservedRoutesGuard],
        data: {roles: [Constants.roles.admin, Constants.roles.customer]}
      },
      {
        path: 'test-image', component: ListTestImageComponent,
        canActivate: [ReservedRoutesGuard],
        data: {roles: [Constants.roles.admin, Constants.roles.customer]}
      },
      {
        path: 'users',
        canActivateChild: [ReservedRoutesGuard],
        data: {roles: Constants.rolesConstants()},
        children: [
          {
            path: 'admins',
            component: ListAdminsComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.admin]}
          },
          {
            path: 'customers',
            children: [
              {
                path: '',
                component: ListCustomersComponent,
                canActivate: [ReservedRoutesGuard],
                data: {roles: [Constants.roles.admin]}
              },
              {
                path: ':id',
                children: [
                  {path: 'testbeds', component: ListTestbedsComponent},
                  {path: 'contracts', component: ListContractsComponent},
                ]
              }
            ],
          },
          {
            path: 'researchers',
            component: ListResearchersComponent,
            data: {roles: [Constants.roles.admin, Constants.roles.customer]}
          },
          {
            path: 'testers',
            component: ListTestersComponent,
            data: {roles: [Constants.roles.admin, Constants.roles.customer, Constants.roles.tester]}
          },
          {
            path: 'logistics',
            component: ListLogisticsComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.admin]}
          },
        ]
      },
      {
        path: 'companies',
        children: [
          {
            path: '',
            component: ListCompaniesComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.admin]}
          },
          {
            path: 'execute',
            component: ExecuteListComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.tester, Constants.roles.customer, Constants.roles.admin]}
          },
          {path: ':companyId/customers', component: ListCustomersComponent},
        ]
      },
      {
        path: 'storage',
        children: [
          {
            path: '',
            component: ListStorageComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.admin]}
          },
        ]
      },
      {
        path: 'certificates', canActivateChild: [ReservedRoutesGuard], data: {roles: [Constants.roles.admin]},
        children: [
          {path: 'box-certificates', component: ListBoxCertificatesComponent},
          {path: 'researcher-certificates', component: ListResearcherCertificatesComponent},
        ]
      },
      {
        path: 'contracts',
        children: [
          {
            path: '',
            component: ListContractsComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.admin, Constants.roles.customer, Constants.roles.logistic, Constants.roles.tester]}
          },
          {
            path: ':id',
            children: [
              {
                path: 'test-list',
                component: TestListPageComponent,
                canActivate: [ReservedRoutesGuard],
                data: {roles: [Constants.roles.admin, Constants.roles.customer, Constants.roles.tester]}
              },
              {
                path: 'output-list',
                component: TestOutputPageComponent,
                canActivate: [ReservedRoutesGuard],
                data: {roles: [Constants.roles.admin, Constants.roles.customer, Constants.roles.tester]}
              },
            ],
          },
        ]
      },
      {
        path: 'testbeds',
        children: [
          {
            path: '',
            component: ListTestbedsComponent,
            canActivate: [ReservedRoutesGuard],
            data: {roles: [Constants.roles.admin, Constants.roles.customer]}
          },
        ]
      },
      //{ path: 'reports', component: TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT, canActivate: [ReservedRoutesGuard], canActivateChild: [ReservedRoutesGuard], data: { roles: [Constants.roles.admin] } },
      // {
      //   path: 'diagnostics',
      //   children: [
      //     {path: 'server-logs',
      //     children: [
      //       {
      //         path: 'system-logs',
      //         component: SystemLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]}
      //       },
      //       {path: 'connection-logs',
      //       component: ConnectionLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]}},
      //       {path: 'operation-logs',
      //       component: OperationLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]}},
      //     ]
      //   },
      //   ]
      // },
      {
        path: 'diagnostics',
        children: [

          {
            path: 'box-logs', component: BoxLogsComponent,
            canActivate: [ReservedRoutesGuard], data: {roles: [Constants.roles.admin, Constants.roles.customer]}
          },

          // {path: 'server-logs', component: TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT},

        ]
      },
      // {
      //   path: 'diagnostics',
      //   children: [
      //     {path: 'box-logs',
      //     // children: [
      //     //   {path: 'box-logs',
      //       component: BoxLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]},
      //       /* {
      //         path: 'interface-logs',
      //         component: InterfaceLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]}
      //       },
      //       {path: 'update-logs',
      //       component: UpdateLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]}},
      //       {path: 'result-update-logs',
      //       component: ResultUpdateLogsComponent,
      //       canActivate: [ReservedRoutesGuard],
      //       data: {roles: [Constants.roles.admin]}}, */
      //       // {path: 'tampering-attempt-logs',
      //       // component: TamperingAttemptLogsComponent,
      //       // canActivate: [ReservedRoutesGuard],
      //       // data: {roles: [Constants.roles.admin]}}
      //     // ]
      //   },
      //   ]
      // },
      {
        path: 'boxes-management',
        canActivateChild: [ReservedRoutesGuard],
        data: {roles: [Constants.roles.admin, Constants.roles.logistic]},
        children: [
          {
            path: 'boxes',
            children: [
              {path: '', component: ListBoxesComponent},
              //{ path: ':id/logistics', component: TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT }
            ]
          },
          {path: 'sims', component: ListSimsComponent},
          {
            path: 'interfaces',
            children: [
              {path: '', component: ListBoxInterfacesComponent},
            ]
          },
        ]
      },
      {
        path: 'invoices',
        children: [
          {path: 'invoices-setup', component: InvoicesSetupComponent},
          {path: 'invoices-items', component: InvoicesItemsComponent},
        ]
      },
      {
        path: 'billing',
        children: [
          {path: 'setup', component: BillingSetupComponent},
          {path: 'items', component: ItemsComponent},
        ]
      },
      {
        path: 'profile',
        children: [
          {path: "", component: UserProfileComponent},
          {path: "edit", component: ProfileManagementComponent}
        ]
      },
      {
        path: 'client-download',
        component: ClientDownloadPageComponent,
        canActivate: [ReservedRoutesGuard],
        data: {roles: [Constants.roles.researcher]}
      },

    ]
  },
  {path: 'not-found', component: PageNotFoundComponent},
  {path: '', redirectTo: '', pathMatch: 'full'},
  {path: '**', component: PageNotFoundComponent},
  // {path: '**', redirectTo: 'not-found'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
